<script setup>
import {computed} from 'vue'

import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const isDisabled = computed(() => {
    const sections = pageEditorStore.pageSections || []
    return sections.map(o => o.id).indexOf(pageEditorStore.activeSectionId) === 0
        || pageEditorStore.moveInProgress
})

const moveUp = () => {
    pageEditorStore.moveSectionUp()
}
</script>

<template>
    <Button @click="moveUp" :disabled="isDisabled" class="btn-sm d-flex align-items-center gap-2">
        <i class="bi bi-chevron-up"></i>
        Move up
    </Button>
</template>